import mediaFinder from "./mediaFinder.vue";
export default mediaFinder;
